import { RewardScene } from '@/types';
import { useReward } from '@/contexts/reward-context';
import { EventPage } from '@/components/event-page';
import { EventRules } from '@/components/event-rules';
import { LevelupPopup, SignInSpinPopup, SignInResultPopup, UM, JackPotNotice, SabaCoinRewardLevel } from '@/components/Popup';
import { EventList } from '@/components/event-list';
import { ExpHistory } from '@/components/exp-history';
import { RankInfo } from '@/components/rank-info';
import { WeeklyAwards } from '@/components/weekly-awards';
import { RankRules } from '@/components/rank_rules';
import { SabaShop } from '@/features/saba-shop';
import { NewVersionPopup } from '@/components/Popup/NewVersion';
import { PurchaseConfirm } from '@/components/purchase-confirm';
import { VoucherList } from '@/features/voucher/components/voucher-list';
import { VoucherRecord } from '@/features/voucher/components/voucher-record';
import { RewardGift } from '@/features/gift-popup/components/reward-gift';
import { OddsBoosterGift } from '@/features/gift-popup/components/odds-booster-gift';
import { BeginnersPack } from '@/features/gift-popup/components/beginners-pack';
import { RfbInfo } from './rfb-info';
import { NotUsed } from '@/features/gift-popup/components/not-used';
// import { SabaCoinRecords } from '@/components/saba-coin-records';

export const AppContainer = () => {
	const { rewardScene, eventListReward, hasReward } = useReward();

	const showEventPage = hasReward && [
		RewardScene.Home,
		RewardScene.Rule,
		RewardScene.EventList,
		RewardScene.ExpHistory,
		RewardScene.Ranking,
		RewardScene.Shop,
		RewardScene.PurchaseConfirm,
		RewardScene.VoucherRecord,
		RewardScene.SabaCoinRecord,
		RewardScene.WeeklyAwards,
		RewardScene.RankingRules
	].includes(rewardScene);

	const showShopPage = [
		RewardScene.Shop,
		RewardScene.PurchaseConfirm,
		RewardScene.MyVouchers,
		RewardScene.VoucherRecord,
		RewardScene.SabaCoinRecord,
		RewardScene.RfbInfo
	].includes(rewardScene);

	return (
		<>
			{
				showEventPage && (
					<div className="reward-wrap">
						<EventPage />
						<EventRules />
						<EventList key={eventListReward?.RewardType} />
						{rewardScene === RewardScene.ExpHistory && <ExpHistory />}
						{rewardScene === RewardScene.Ranking && <RankInfo />}
						{rewardScene === RewardScene.RankingRules && <RankRules />}
						{rewardScene === RewardScene.WeeklyAwards && <WeeklyAwards />}
					</div>
				)
			}
			{
				showShopPage && (
					<div className="shop" data-open="true">
						<div
							id="shop-wrapper"
							className="shop-wrap"
						>
							{rewardScene === RewardScene.MyVouchers ? (
								<VoucherList />
							) : rewardScene === RewardScene.VoucherRecord ? (
								<VoucherRecord />
							) : (
								hasReward ? <SabaShop /> : null
							)}

							{/* {rewardScene === RewardScene.SabaCoinRecord && <SabaCoinRecords />} */}
						</div>
					</div>
				)
			}
			{ showShopPage && rewardScene !== RewardScene.MyVouchers && <SabaCoinRewardLevel /> }
			{
				{
					[RewardScene.BeginnersPackPopup]: <BeginnersPack />,
					[RewardScene.RewardGift]: <RewardGift />,
					[RewardScene.OddsBoosterGift]: <OddsBoosterGift />,
					[RewardScene.LevelupPopup]: <LevelupPopup />,
					[RewardScene.SignInSpin]: <SignInSpinPopup />,
					[RewardScene.SignInResult]: <SignInResultPopup />,
					[RewardScene.NewVersion]: <NewVersionPopup />,
					[RewardScene.PurchaseConfirm]: <PurchaseConfirm />,
					[RewardScene.UM]: <UM />,
					[RewardScene.JackPotNotice]: <JackPotNotice />,
					[RewardScene.RfbInfo]: <RfbInfo />,
					[RewardScene.NotUsed]: <NotUsed />
				}[rewardScene]
			}
		</>
	);
};
